"use client";

import {
  Driveline,
  Fal,
  Glif,
  Brilliant,
  VisualLayer,
  Voxel,
  Photoroom,
  CalPoly,
} from "@/components/svg";

const logos = [
  Driveline,
  Glif,
  Fal,
  Brilliant,
  VisualLayer,
  Voxel,
  Photoroom,
  CalPoly,
];

/** A strip of logos that scrolls horizontally */
const Logos = () => {
  return (
    <section className="container max-w-6xl mx-auto overflow-hidden opacity-50">
      <h2 className="text-center opacity-80">Moondream is trusted by</h2>
      <div className="flex w-full">
        {/* First marquee group */}
        <div className="flex shrink-0 animate-marquee items-center">
          {logos.map((Logo, index) => (
            <div key={index} className="p-6 mx-6">
              <Logo />
            </div>
          ))}
        </div>
        {/* Second marquee group */}
        <div className="flex shrink-0 animate-marquee items-center">
          {logos.map((Logo, index) => (
            <div key={index} className="p-6 mx-6">
              <Logo />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Logos;
